import { render, staticRenderFns } from "./dynamicBody.vue?vue&type=template&id=5674c5f6&scoped=true&"
import script from "./dynamicBody.vue?vue&type=script&lang=js&"
export * from "./dynamicBody.vue?vue&type=script&lang=js&"
import style0 from "./dynamicBody.vue?vue&type=style&index=0&id=5674c5f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5674c5f6",
  null
  
)

export default component.exports